import React from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func } from 'prop-types'

import { NOOP } from 'Utils/stableDefaults'

function SubscriptionEmptyState({ onEnable = NOOP, showEnableButton = true }) {
  const title = showEnableButton
    ? 'You are not earning from subscription yet'
    : 'No subscription earnings this period'

  const description = showEnableButton
    ? 'Enable Maximize Earnings to include your eligible models in the Essentials catalog'
      + ' and start earning passive income from subscription downloads.'
    : 'Your models are enrolled in the Essentials catalog.'
      + ' Earnings will appear here once subscribers download them.'

  return (
    <div
      className="subscription-detail-panel__empty-state"
      role="status"
      aria-live="polite"
    >
      <h3 className="subscription-detail-panel__empty-state-title cgt-heading-400">
        {title}
      </h3>
      <p className="subscription-detail-panel__empty-state-description cgt-body-base">
        {description}
      </p>
      {showEnableButton && (
        <Button
          type="primary"
          size="small"
          onClick={onEnable}
          customClass="subscription-detail-panel__empty-state-action"
        >
          Enable Maximize Earnings
        </Button>
      )}
    </div>
  )
}

SubscriptionEmptyState.propTypes = {
  onEnable: func,
  showEnableButton: bool,
}

export default SubscriptionEmptyState
